<template>
    <div>
        <hos_apply_title title="病情资料"></hos_apply_title>
        <el-form :model="detail" class="mt10" label-position="left" size="mini">
            <el-form-item label="初步诊断" label-width="80px" class="marginBottom">
                <el-input v-model="detail.tentativeDiagnosis" :readonly="readyOnly()"></el-input>
            </el-form-item>
            <el-form-item label="病情描述" label-width="80px" class="marginBottom">
                <el-input type="textarea" @input="changeLength"  :autosize="{ minRows: 4, maxRows: 10}" placeholder="请输入病情内容最多输入500字..." v-model="detail.illnessDescription" :maxlength="500" :readonly="readyOnly()">
                </el-input>
            </el-form-item>
            <el-form-item label="病历附件" label-width="80px" class="marginBottom">
                <hos_flie_load :from="from" :atta="detail.attaList" :state="detail.referralStatus" ref="load"></hos_flie_load>
            </el-form-item>
            <el-form-item label-width="80px" v-if="from == 'init' && !(detail.referralStatus == 'CANCEL' || detail.referralStatus == 'REFUSED')" class="marginBottom">
                <hos_tip></hos_tip>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import hos_apply_title from "../../components/hos/hos-apply-title"
    import hos_flie_load from "../../components/hos/hos-flie-load"
    import hos_tip from "../../components/hos/hos-tip"
    export default {
        name: "referral-condition-form-detail",
        components:{hos_apply_title,hos_tip,hos_flie_load},
        props:{
            from:{
                type:String,
                default:'init'
            },
            detail:{
                type:Object
            }
        },
        data(){
            return {

            }
        },
        methods:{
            getAttrList(){
                let from = {
                    tentativeDiagnosis:this.detail.tentativeDiagnosis,
                    illnessDescription:this.detail.illnessDescription
                }
                from = Object.assign({},from,this.$refs['load'].getAttaList());
                return from
            },
            readyOnly(){
                // if(this.from == 'init'){
                //     if(this.detail.referralStatus == 'CANCEL' || this.detail.referralStatus == 'REFUSED'){
                //         return true
                //     }
                //     return false
                // }else{
                //     return true
                // }
                return true
            },
            changeLength(){
                if(this.diseaseInfoForm.illnessDescription.length >= 500){
                    this.$message.error('字数超出限制。');
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/hos";
</style>